import $ from "jquery";

const SELECTOR_SELECTED_OPTION = "select option:selected[disabled]";
const SELECTOR_PLACEHOLDER_OPTION = 'select option[value=""]';
const CLASS_PLACEHOLDER = "has-placeholder";

const initSelectDisabledOption = function () {
  $(SELECTOR_PLACEHOLDER_OPTION).prop("disabled", true);
};

const initSelectPlaceholders = function () {
  $(SELECTOR_SELECTED_OPTION)
    .parent()
    .addClass(CLASS_PLACEHOLDER)
    .one("change", function () {
      $(this).removeClass(CLASS_PLACEHOLDER);
    });
};

// PUBLIC
const init = function () {
  initSelectDisabledOption();
  initSelectPlaceholders();
};

if (window.Drupal) {
  window.Drupal.behaviors.formSelect = {
    attach() {
      init();
    },
  };
} else {
  $(function () {
    init();
  });
}

$(document).on("storybook:component:change", function () {
  init();
});
